<div id="overlay" *ngIf=showOverlay fxLayout="column" fxLayoutAlign="start center">
    <div class="header" fxLayoutAlign="center center" fxFlex="45px">
        <div class="button-wrapper" fxLayoutAlign="center center">
            <div class="close-button" (click)="toggleOverlay()" fxLayout="column" fxLayoutAlign="center center">Close
            </div>
        </div>
    </div>
    <div fxFlexFill>
        <ngx-extended-pdf-viewer [base64Src]="base64Src" [useBrowserLocale]="false" [showOpenFileButton]="false" [showPrintButton]="false" [showBookmarkButton]="false" (afterPrint)="onPrintPdf('afterPrint', $event)" (pdfDownloaded)="onDownloadPdf('pdfDownloaded', $event)"></ngx-extended-pdf-viewer>
    </div>
</div>
<div class="minor-page-wrapper" fxLayout="column" fxLayoutAlign="start center">
    <div fxLayout="column" fxLayoutGap="10px" fxFlexFill>
        <div fxLayout="column" fxFlex>
            <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Monthly
                Statements
            </div>
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="statementsDataSource" matSort #statementsSort="matSort">
                    <!-- Trade Date Column -->
                    <ng-container matColumnDef="effectiveDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.effectiveDate | date: 'MM/dd/yyyy' }} </td>
                    </ng-container>
                    <!-- Trans. # Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
                    </ng-container>
                    <!-- Position Type -->
                    <ng-container matColumnDef="pdf">
                        <th mat-header-cell *matHeaderCellDef> PDF </th>
                        <td mat-cell *matCellDef="let row">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <fa-icon style="cursor: pointer;" (click)="onShowPdf(row)" [icon]="['far', 'file-pdf']"
                                    size="lg" fxFlex="35px">
                                </fa-icon>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="statementsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: statementsColumns;"></tr>
                </table>
                <mat-paginator #statementsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
        <div fxLayout="column" fxFlex>
            <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Trade
                Confirmations
            </div>
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="confirmationsDataSource" matSort #confirmationsSort="matSort">
                    <!-- Trade Date Column -->
                    <ng-container matColumnDef="effectiveDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.effectiveDate | date: 'MM/dd/yyyy' }} </td>
                    </ng-container>
                    <!-- Trans. # Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
                    </ng-container>
                    <!-- Position Type -->
                    <ng-container matColumnDef="pdf">
                        <th mat-header-cell *matHeaderCellDef> PDF </th>
                        <td mat-cell *matCellDef="let row">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <fa-icon style="cursor: pointer;" (click)="onShowPdf(row)" [icon]="['far', 'file-pdf']"
                                    size="lg" fxFlex="35px">
                                </fa-icon>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="confirmationsColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: confirmationsColumns;"></tr>
                </table>
                <mat-paginator #confirmationsPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
                </mat-paginator>
            </div>
        </div>
        <div fxLayout="column" fxFlex>
            <div class="panel-headers" fxLayout="row" fxLayoutAlign="center center" style="height:40px;">Year End
                Summaries
            </div>
            <div class="mat-elevation-z8">
                <table mat-table [dataSource]="summariesDataSource" matSort #summariesSort="matSort">
                    <!-- Trade Date Column -->
                    <ng-container matColumnDef="effectiveDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.effectiveDate | date: 'MM/dd/yyyy' }} </td>
                    </ng-container>
                    <!-- Trans. # Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description </th>
                        <td mat-cell *matCellDef="let element"> {{ element.type }} </td>
                    </ng-container>
                    <!-- Position Type -->
                    <ng-container matColumnDef="pdf">
                        <th mat-header-cell *matHeaderCellDef> PDF </th>
                        <td mat-cell *matCellDef="let row">
                            <div fxLayout="row" fxLayoutAlign="start center">
                                <fa-icon style="cursor: pointer;" (click)="onShowPdf(row)" [icon]="['far', 'file-pdf']"
                                    size="lg" fxFlex="35px">
                                </fa-icon>
                            </div>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="summariesColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: summariesColumns;"></tr>
                </table>
                <mat-paginator #summariesPaginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>